import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  const heightLinha = "25px";
  // const heightFavorita = "40px";
  return ({
    root: {
      width: "100%",
      paddingLeft: 20,
      height: "50px",
    },
    favoriteRoot: {
     width: "100%",
      paddingLeft: 20,
      height: "50px",
      background:theme.palette.primary.main,
      "&:hover": {
        background: theme.palette.primary.dark,
      },
    },
    text: {
      marginLeft: "-10px",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      fontWeight: 450,
      fontSize: "15px",
      color: theme.palette.text.primary,
    },
    icon: {
      fill: theme.palette.primary.main,
      width: heightLinha,
      height: heightLinha,
    },
    favoriteIcon: {
      width: heightLinha,
      height: heightLinha,
      fill: theme.palette.secondary.light,
    }
    ,
    favoriteText: {
      color: theme.palette.secondary.light,
      marginLeft: "-10px",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      fontWeight: 450,
      fontSize: "15px",
    }
  })
});
